import { IManualCheckDisbursementData } from '../../../../../types/order/escrow/IManualCheckDisbursementData';
import React from 'react';
import { BodyText, Button, FlexRow, Tooltip } from '../../../../../ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPennant } from '@fortawesome/pro-solid-svg-icons';

export const CreateEditManualCheckDisbursementAlertAndPDFButton: React.FC<{
  check: IManualCheckDisbursementData;
  hasEditPermission: boolean;
  onCreatePDF: (checkId: string) => void;
}> = ({ check, hasEditPermission, onCreatePDF }) => {
  return (
    <>
      {check.id && (
        <>
          <FlexRow justifyContent={'start'} verticalAlign={'center'}>
            {check.checkDate === undefined && check.createdAt && (
              <Tooltip
                trigger={'hover'}
                placement={'bottom'}
                tooltipContent={<BodyText>Check cannot be marked as sent until PDF has been created.</BodyText>}
              >
                <FontAwesomeIcon icon={faPennant} color={'red'} />
              </Tooltip>
            )}
            <Button
              intent={'primary'}
              onClick={() => {
                onCreatePDF(check.id);
              }}
              disabled={!hasEditPermission}
            >
              Create PDF
            </Button>
          </FlexRow>
        </>
      )}
    </>
  );
};
